import { API_URL_BASE, htmlElem } from '../utils/globals';
import { fetchPage } from './fetchPage';
import { fetchLinkedPage } from './fetchLinkedPage';
import { appendNavigationData } from './appendNavigationData';
import { addToSessionStorage, retrieveFromSessionStorage } from '../utils/utilsStorage';
import { compare } from '../utils/compare';
import { removeChildNodes } from '../utils/removeChildNodes';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';
import { subNavigation } from './subNavigation';

const fetchNavigationPrivate = (tagId) => {
    const privatePagesData = retrieveFromSessionStorage('privatePages');
    if (privatePagesData !== null) {
        subNavigation();
        fetchPage();
    } else {
        fetch(`${API_URL_BASE}/pages?tags=${tagId}`)
            .then((response) => response.json())
            .then((data) => {
                setAjaxLoading(htmlElem);
                const sortedData = data.sort(function(a, b) {
                    return compare(b.menu_order, a.menu_order) || compare(b.date, a.date)
                });
                addToSessionStorage('privatePages', sortedData);
                subNavigation();
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setAjaxComplete(htmlElem);
                fetchLinkedPage();
                fetchPage();
            });
        }
}

export {
    fetchNavigationPrivate
}